module.exports = __webpack_public_path__ + "img/Upload-file-2.e4d57dd3.svg";